import { MDBBadge, MDBBtn, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBTabs, MDBTabsItem } from 'mdb-react-ui-kit';
import React from 'react';
import { NavLink, useParams } from 'react-router-dom';
import request from '../util/client';
import { delToken, hasLoggedIn } from '../util/token';
import env from '../env.json';

export default function Nav() {
  const [categories, setCategories] = React.useState([]);
  const [status, setStatus] = React.useState(hasLoggedIn());
  const [info, setInfo] = React.useState(JSON.parse(window.localStorage.getItem('info') || '{}'));
  const params = useParams();
  React.useEffect(() => {
    request('index/channel/info', 'POST').then(response => {
      setCategories(response.data.channelInfo);
    });
    document.addEventListener('loginstatuschange', e => {
      setStatus(hasLoggedIn());
      setInfo(e.data || {});
    });
  }, []);
  const container = React.useRef();
  const onWheel = React.useRef(e => {
    if (e.deltaY) {
      e.stopPropagation();
      container.current.scrollLeft += e.deltaY;
    }
  });
  const login = React.useRef(e => {
    e.stopPropagation();
    e.preventDefault();
    document.dispatchEvent(new Event('login'));
  });
  const logout = React.useRef(e => {
    e.stopPropagation();
    e.preventDefault();
    delToken();
    window.localStorage.clear();
    setStatus(false);
    setInfo({});
  });
  return (
    <>
      <nav className="nav-container" onWheel={onWheel.current} ref={container}>
        <h1 className="logo">
          <img src={env.RES_URL + 'logo.svg'} width="28" height="28" alt="Linky" />
          <strong className="sr-only">Linky</strong>
        </h1>
        <MDBTabs pills>
          <MDBTabsItem>
            <NavLink to='/app/' className={() => params.category ? 'nav-link' : 'nav-link active'}>推荐</NavLink>
          </MDBTabsItem>
          {categories.map(category => (
            <MDBTabsItem key={'category-' + category.id}>
              <NavLink to={'/app/category/' + category.id} className={() => parseInt(params.category) === parseInt(category.id) ? 'nav-link active' : 'nav-link'}>
                {category.name}
              </NavLink>
            </MDBTabsItem>
          ))}
        </MDBTabs>
      </nav>
      {status ? (
        <MDBDropdown>
          <MDBDropdownToggle><img src={info.avatar || 'https://sanshizhen.oss-cn-beijing.aliyuncs.com/resources/upload/img/20200521/73dc0329-ed45-4a39-a6f1-63d0f9bae81b.png'} alt={info.nickname} /></MDBDropdownToggle>
          <MDBDropdownMenu>
            {/* <MDBDropdownItem divider /> */}
            <MDBDropdownItem link onClick={logout.current}>退出登录</MDBDropdownItem>
          </MDBDropdownMenu>
        </MDBDropdown>
      ) : (
        <MDBBtn type="link" className="btn-login" onClick={login.current}>
          <img src="https://sanshizhen.oss-cn-beijing.aliyuncs.com/resources/upload/img/20200521/73dc0329-ed45-4a39-a6f1-63d0f9bae81b.png" alt="未登录" />
          <MDBBadge color='danger' notification pill>未登录</MDBBadge>
        </MDBBtn>
      )}
    </>
  );
}
